import { Navigate, Outlet, useLocation } from 'react-router'
import { RouteSkeleton } from '../ds/states/RouteSkeleton'
import { useAuth } from './AuthContext'

export default function RequireAuth() {
  const { user, status } = useAuth()
  const location = useLocation()
  // Zimne wejście (G2-auth-onboarding-07, artboard 01 sesji 08): powłoka stoi, treść
  // ma kształt Generatora — ten sam `RouteSkeleton`, który dostaje leniwa trasa.
  if (status === 'loading') return <RouteSkeleton shell />
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />
  return <Outlet />
}
